import React from 'react';
import { Box } from '@mui/material';

export function ModelCardWrapper({ children, inCarousel = false }) {
    return (
        <Box
            sx={{
                // Padding to accommodate shadows in all contexts
                p: 1,
                // Ensure the card takes up the available space minus padding
                '& > *': {
                    width: '100%',
                    height: '100%'
                }
            }}
        >
            {children}
        </Box>
    );
}